// Modules
import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from '../ReactCSSTransitionGroupCompat/ReactCSSTransitionGroupCompat';
// Components
import VerificationCodeSection from './Sections/VerificationCodeSection';
import PhoneNumberSection from './Sections/PhoneNumberSection';
// Styles
import * as styles from './PhoneVerificationFormMyAccount.scss';

const PhoneVerificationFormMyAccount = (props) => {
  const phoneNumberSection = (
    <PhoneNumberSection
      translate={props.translate}
      locale={props.locale}
      onChange={props.onChange}
      validatePhoneNumber={props.validatePhoneNumber}
      sendPhoneNumber={props.sendPhoneNumber}
      fetchReCaptchaToken={props.fetchReCaptchaToken}
      phoneForCaptcha={props.phoneForCaptcha}
      phoneNumberIsInvalid={props.phoneNumberIsInvalid}
      phoneNumberSent={props.phoneNumberSent}
      showPhonePreloader={props.showPhonePreloader}
      isMobile={props.isMobile}
      errorMessage={props.errorMessage}
      showErrorMessage={props.showErrorMessage}
      doResetCaptcha={props.doResetCaptcha}
      phoneNumberAlreadyTaken={props.phoneNumberAlreadyTaken}
      isRtl={props.isRtl}
      tooltipMsg={props.tooltipMsg}
      initialPhoneValue={props.initialPhoneValue}
      phoneIsVerified={props.phoneIsVerified}
      onPhoneChange={props.onPhoneChange}
    />
  );

  const codeSection = (props.phoneNumberSent && !props.phoneIsVerified) && (
    <VerificationCodeSection
      translate={props.translate}
      onChange={props.onChange}
      validateCode={props.validateCode}
      codeIsValid={props.codeIsValid}
      showCodePreloader={props.showCodePreloader}
      codeIsVerified={props.codeIsVerified}
      isRtl={props.isRtl}
    />
  );

  return (
    <div className={styles.verificationForm}>
      <div className={styles.content}>
        <span className={styles.label}>
          {props.translate('phoneNumber')}
        </span>
        <div>
          {phoneNumberSection}
          <ReactCSSTransitionGroup
            transitionName="code-section"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={400}
          >
            {codeSection}
          </ReactCSSTransitionGroup>
        </div>
      </div>
    </div>
  );
};

PhoneVerificationFormMyAccount.propTypes = {
  translate: PropTypes.func,
  tooltipMsg: PropTypes.string,
  locale: PropTypes.string,
  onChange: PropTypes.func,
  onPhoneChange: PropTypes.func,
  validateCode: PropTypes.func,
  validatePhoneNumber: PropTypes.func,
  sendPhoneNumber: PropTypes.func,
  fetchReCaptchaToken: PropTypes.func,
  phoneForCaptcha: PropTypes.string,
  phoneNumberSent: PropTypes.bool,
  codeIsValid: PropTypes.bool,
  codeIsVerified: PropTypes.bool,
  phoneNumberIsInvalid: PropTypes.bool,
  showCodePreloader: PropTypes.bool,
  showPhonePreloader: PropTypes.bool,
  isMobile: PropTypes.bool,
  showErrorMessage: PropTypes.bool,
  doResetCaptcha: PropTypes.bool,
  errorMessage: PropTypes.string,
  phoneNumberAlreadyTaken: PropTypes.bool,
  isRtl: PropTypes.bool,
  phoneIsVerified: PropTypes.bool,
  initialPhoneValue: PropTypes.string
};

export default PhoneVerificationFormMyAccount;
